// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"535":"1db93a2d","865":"c1f780bb"}[chunkId] + ".chunk.css";
};